import {Button, Flex, Icon, Spinner, Text, VStack} from "@chakra-ui/react";
import {HiOutlineCpuChip} from "react-icons/hi2";
import {useEffect, useState} from "react";
import ConfigureWorkerModal from "@/pages/workers/components/ConfigureWorkerModal";
import WorkerService from "@/services/agency/WorkerService";
import WorkerListItem from "@/components/ui/workers/WorkerListItem";
import {useWorkerContext} from "@/components/providers/WorkerProvider";

const WorkersPage = () => {
    const { workerObjects, isLoading, refresh } = useWorkerContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [workers, setWorkers] = useState([]);
    const [selectedWorker, setSelectedWorker] = useState(null);

    useEffect(() => { setWorkers(workerObjects); }, [workerObjects]);

    const handleEdit = (worker) => {
        setSelectedWorker(worker);
        setIsModalOpen(true);
    };

    const handleAdd = () => {
        setSelectedWorker(null);
        setIsModalOpen(true);
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setSelectedWorker(null);
    };

    const handleSave = (data) => {
        if (data.id) {
            return WorkerService.update(data).then(updated => {
                setWorkers(prev => prev.map(w => w.id === updated.id ? updated : w));
                refresh();
            });
        } else {
            return WorkerService.create(data).then(created => {
                setWorkers(prev => [...prev, created]);
                refresh();
            });
        }
    };

    if (isLoading) {
        return (
            <Flex w={'full'} py={24} alignItems={'center'} justifyContent={'center'}>
                <Spinner size={'xl'} color={'white'}/>
            </Flex>
        );
    }

    return (
        <VStack w={'full'} rowGap={6}>
            <Flex flexDirection={'row'} justifyContent={'flex-end'} w={'full'}>
                <Button variant="primary" textDecoration='unset' onClick={handleAdd}>
                    <Icon fontSize={46}>
                        <HiOutlineCpuChip/>
                    </Icon>
                    <Text>Configure Worker</Text>
                </Button>
            </Flex>
            {workers.map(worker => (
                <WorkerListItem key={worker.id} worker={worker} onEdit={handleEdit}/>
            ))}
            <ConfigureWorkerModal
                isOpen={isModalOpen}
                onClose={handleClose}
                onSave={handleSave}
                worker={selectedWorker}
            />
        </VStack>
    );
};

export default WorkersPage;
